var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "border-a pa-6 row-pointer rounded",
        attrs: {
          headers: _vm.generateHeaders(_vm.tableConfig),
          items: _vm.$store.getters["adminUsers/users"],
          options: _vm.groupOptions,
          "server-items-length": _vm.$store.getters["adminUsers/totalItems"],
          "item-key": "ID",
          loading: _vm.loading || _vm.$store.getters["adminUsers/isLoading"],
          "loading-text": _vm.$t("common.loading"),
          "footer-props": _vm.$store.getters["adminUsers/footerProps"],
          "multi-sort": "",
          "mobile-breakpoint": "0"
        },
        on: {
          "update:options": function($event) {
            _vm.groupOptions = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c("va-table-top", {
                  attrs: {
                    title: _vm.$t("usersList.adminUsers"),
                    subtitle: _vm.$t("usersList.adminDescription"),
                    cta: _vm.$t("common.user")
                  },
                  on: { ctaClick: _vm.onCreate },
                  model: {
                    value: _vm.searchString,
                    callback: function($$v) {
                      _vm.searchString = $$v
                    },
                    expression: "searchString"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "no-data",
            fn: function() {
              return [_c("va-no-data-tag")]
            },
            proxy: true
          },
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("va-badge", {
                  attrs: {
                    text: _vm.$t("usersList." + item.status),
                    color: item.status == "active" ? "success" : "warning",
                    size: "s",
                    "icon-class":
                      item.status == "active"
                        ? "vi vi-c-check"
                        : "vi vi-c-warning"
                  }
                })
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "", "z-index": "11" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "div",
                                    _vm._g({}, on),
                                    [
                                      item.status == "pending" ||
                                      item.status == "expired"
                                        ? _c("va-button", {
                                            staticClass: "mr-2",
                                            attrs: {
                                              cta: "b",
                                              icon: "vi vi-trash-1",
                                              type: "square",
                                              color: "error"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onDeleteInvitation(
                                                  item
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("usersList.deleteInvitation")))
                        ])
                      ]
                    ),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "", "z-index": "11" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "div",
                                    _vm._g({}, on),
                                    [
                                      item.status == "pending" ||
                                      item.status == "expired"
                                        ? _c("va-button", {
                                            attrs: {
                                              cta: "b",
                                              icon: "vi vi-paper-plane",
                                              type: "square"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onResend(item)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("usersList.resendInvitation")))
                        ])
                      ]
                    ),
                    item.status !== "pending" &&
                    item.status != "expired" &&
                    false
                      ? _c("va-button", {
                          attrs: {
                            cta: _vm.$t("common.delete"),
                            color: "error"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDeleteUser(item)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "va-dialog", scrollable: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "va-card",
            [
              _c("div", { staticClass: "va-title" }, [
                _vm._v(_vm._s(_vm.$t("usersList.inviteAdmin")))
              ]),
              _c(
                "v-form",
                {
                  ref: "newGroupForm",
                  attrs: { "lazy-validation": "", onSubmit: "return false;" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("va-text-field", {
                    staticClass: "mb-6",
                    attrs: {
                      rules: [_vm.required, _vm.validMail],
                      label: _vm.$t("common.email"),
                      disabled:
                        _vm.loading ||
                        _vm.$store.getters["adminUsers/isLoading"] ||
                        _vm.mailChecked
                    },
                    model: {
                      value: _vm.user.email,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "email", $$v)
                      },
                      expression: "user.email"
                    }
                  }),
                  _vm.mailChecked
                    ? _c("va-text-field", {
                        staticClass: "mb-6",
                        attrs: {
                          rules: [_vm.required],
                          label: _vm.$t("common.firstname"),
                          disabled:
                            _vm.loading ||
                            _vm.$store.getters["adminUsers/isLoading"]
                        },
                        model: {
                          value: _vm.user.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "firstName", $$v)
                          },
                          expression: "user.firstName"
                        }
                      })
                    : _vm._e(),
                  _vm.mailChecked
                    ? _c("va-text-field", {
                        staticClass: "mb-6",
                        attrs: {
                          rules: [_vm.required],
                          label: _vm.$t("common.lastname"),
                          disabled:
                            _vm.loading ||
                            _vm.$store.getters["adminUsers/isLoading"]
                        },
                        model: {
                          value: _vm.user.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "lastName", $$v)
                          },
                          expression: "user.lastName"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c("va-button", {
                        staticClass: "mr-4",
                        attrs: {
                          color: "secondary",
                          type: "outline",
                          loading:
                            _vm.loading ||
                            _vm.$store.getters["adminUsers/isLoading"],
                          cta: _vm.$t("common.dismiss")
                        },
                        on: {
                          click: function($event) {
                            _vm.dialog = false
                          }
                        }
                      }),
                      !_vm.mailChecked
                        ? _c("va-button", {
                            attrs: {
                              disabled: !_vm.valid || _vm.user.email == "",
                              loading:
                                _vm.loading ||
                                _vm.$store.getters["adminUsers/isLoading"],
                              cta: _vm.$t("usersList.checkEmail")
                            },
                            on: { click: _vm.onCheck }
                          })
                        : _c("va-button", {
                            attrs: {
                              submit: "",
                              disabled:
                                !_vm.valid ||
                                _vm.user.firstName == "" ||
                                _vm.user.lastName == "",
                              loading:
                                _vm.loading ||
                                _vm.$store.getters["adminUsers/isLoading"],
                              cta: _vm.$t("usersList.invite")
                            },
                            on: { click: _vm.onInvite }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }